import { render, staticRenderFns } from "./SolanaTransactions.vue?vue&type=template&id=0637c8fa"
import script from "./SolanaTransactions.vue?vue&type=script&lang=js"
export * from "./SolanaTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports